import React, { useContext, useEffect, useState } from "react";
import { Student } from "../../__generated__/graphql";


export type studentData = Student;

export type StudentContent = {
    studentData: any | null;
    bulkStudents: { allStudents: studentData[], crashedStudents: studentData[], successfulStudents: studentData[] };
    changeStudent: (student: any) => void;
    updateStudent: (student: studentData | null | undefined) => void,
    updateBulkStudents: (assign: studentData[], unassign: studentData[], crash: studentData[], success: studentData[]) => void
}

const StudentContext = React.createContext<StudentContent>({
    studentData: null,
    bulkStudents: { allStudents: [], crashedStudents: [], successfulStudents: [] },
    updateStudent: (student: studentData | null | undefined) => { },
    changeStudent: () => { },
    updateBulkStudents: (assign: studentData[], unassign: studentData[], crash: studentData[], success: studentData[]) => { },
});

StudentContext.displayName = 'StudentContext';

const useStudentContext = () => useContext(StudentContext)

interface IProps {
    children: React.ReactNode
}

const StudentDataProvider = (props: IProps) => {

    const { children } = props;
    const [studentData, setStudentData] = useState<studentData | null>(null);
    const [bulkStudents, setBulkStudents] = useState<{
        allStudents: studentData[],
        crashedStudents: studentData[]
        successfulStudents: studentData[]
    }>({
        allStudents: [],
        crashedStudents: [],
        successfulStudents: []
    });

    const handleUpdateStudent = (student: studentData | null | undefined) => {
        if (!student) return;

        setStudentData((state) => {
            const newState = {
                ...state,
                ...student
            }
            return newState;
        });
    }
    const handleChangeStudent = (student: any) => {
        if (student != null) {
            const data = {
                ...student,
            }
            setStudentData(data);
        }
    }

    const handleUpdateBulkStudents = (assign: studentData[], unassign: studentData[], crash: studentData[], success: studentData[]) => {
        if (assign.length === 0 && unassign.length === 0 && crash.length === 0 && success.length === 0) {
            //SAFETY WE WANT TO CLEAR THE BULK QUEUE
            //COME BACK WITH FRESH EYES
            setBulkStudents({
                allStudents: [],
                crashedStudents: [],
                successfulStudents: []
            })
            return;
        }
        setBulkStudents((prevState) => {
            let updatedAll = [...prevState.allStudents]
            // let updatedCrash = [...prevState.crashedStudents]
            assign.forEach(student => {
                if (!updatedAll.some(x => x.id === student.id)) {
                    updatedAll.push(student)
                }
            })
            unassign.forEach(student => {
                const index = updatedAll.findIndex(x => x.id === student.id)
                if (index != -1) {
                    updatedAll.splice(index, 1)
                }
            })
            const updatedCrash = crash;
            const updatedSuccess = success

            return {
                allStudents: updatedAll,
                crashedStudents: updatedCrash,
                successfulStudents: updatedSuccess
            }
        })

    }


    return (
        <StudentContext.Provider value={{
            studentData,
            bulkStudents,
            changeStudent: handleChangeStudent,
            updateStudent: handleUpdateStudent,
            updateBulkStudents: handleUpdateBulkStudents,
        }} >
            {children}
        </StudentContext.Provider>
    );
};

export { useStudentContext, StudentDataProvider };
